import { useState, useEffect } from "react";
import { FaHeart } from "react-icons/fa";

interface HeartProps {
  "data-testid"?: string;
}

const Heart = ({ "data-testid": testId }: HeartProps) => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
    }, 2000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <>
      <style>
        {`@keyframes fly {
  0% {
    opacity: 0;
  }
  25% {
    transform: translateX(60%);
  }
  50% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    bottom: 100px;
    transform: translateX(150%);
  }
}
    }`}
      </style>
      <div
        data-testid={testId}
        style={{
          animation: `fly 3s ease-in-out`,
        }}
        className={`tw-absolute tw-bottom-[30px] tw-left-[30%] tw-translate-x-[-50%] tw-animate-fly ${
          show ? "tw-block" : "tw-hidden"
        }`}
      >
        <FaHeart className="tw-text-pink-300" size="1.2rem" />
      </div>
    </>
  );
};

export default Heart;
